import React, { useEffect, useRef, useState } from "react";
import { InputSearch } from "../../../../controls";
import { action, API, controller } from "../../../../api/api";
import { ToFormData, useFormatPrice } from "../../../../hooks/Method";

const InputSelectItem = ({ values, setValues }) => {
  const formatPrice = useFormatPrice();
  const inputRef = useRef();
  const [searchVal, setSearchVal] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const inputBoxFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 10);
  };

  const handleClear = () => {
    setSearchVal("");
    setProducts([]);
    inputBoxFocus();
  };

  useEffect(() => {
    inputBoxFocus();
    return () => {};
  }, []);

  const handleAdd = (val) => {
    if (val.prodType !== 2)
      handleSelectProd({
        ...val,
        isVariant: false,
        label: val.prod.name,
        subtitle:
          (val.prod.skuCode && `${val.prod.skuCode} | `) +
          formatPrice(val.prod.splrPrice || 0),
      });
    else
      handleSelectProd({
        ...val,
        isVariant: true,
        label: `${
          val.prod.name +
          " / " +
          val.varProd.attrVal1 +
          (val.varProd.attrVal2 && ` / ${val.varProd.attrVal2}`) +
          (val.varProd.attrVal3 && ` / ${val.varProd.attrVal3}`)
        }`,
        subtitle:
          (val.varProd.skuCode && `${val.varProd.skuCode} | `) +
          formatPrice(val.varProd.splrPrice || 0),
      });
  };

  const handleSelectProd = (prod) => {
    if (
      !values.stockProds.some(
        (j) => j.prodId === prod.prodId && j.varProdId === prod.varProdId
      )
    ) {
      setValues((x) => ({
        ...x,
        stockProds: [
          {
            name: prod.label,
            subtitle: prod.subtitle,
            prodId: prod.prodId,
            varProdId: prod.varProdId,
            splrPrice: prod.splrPrice,
            isVariant: prod.isVariant,
            img: prod.img,
            prod: prod,
            unitPrice: prod.splrPrice || 0,
            totalPrice: 0,
            prevStock: "",

            mfgDate: "",
            expDate: "",

            // Inventories
            orderInvsFor: x.orderingFor.map((val) => ({
              outletId: Number.isInteger(val) ? val : val.outletId,
              qty: "",
              receivedQty: "",
              previousStock: 0,
            })),
            totalQty: 0,
          },
          ...x.stockProds,
        ],
      }));
    } else if (
      values.stockProds.some(
        (j) => j.prodId === prod.id && j.varProdId === prod.varProdId
      )
    ) {
      setValues((x) => ({
        ...x,
        stockProds: x.stockProds.map((j) =>
          j.prodId === prod.id && j.varProdId === prod.varProdId
            ? { ...j, qty: parseFloat(j.qty) + 1 }
            : j
        ),
      }));
    }
    setErrorMsg("");
  };

  const handleScan = () => {
    setLoading(true);
    API(controller.Product + action.ProductScanBySplr).post(
      ToFormData({ supplierId: values.splrId, value: searchVal }),
      (res) => {
        handleClear();
        if (res?.status === 200) handleAdd(res.result);
        else setErrorMsg("Product not found");
        setLoading(false);
      }
    );
  };

  const handleSelect = (e, newVal) => {
    if (e.key === "Enter" && newVal && !newVal?.id) handleScan();
    else if (newVal) {
      setLoading(true);
      API(controller.Product + action.ProdSelectForCart).post(
        ToFormData({
          productId: newVal.id,
          isVariant: newVal.isVariant,
        }),
        (res) => {
          if (res?.status === 200) handleAdd(res.result);
          handleClear();
          setLoading(false);
        }
      );
    }
  };

  const handleInpChg = (e, newVal) => {
    setErrorMsg("");
    setSearchVal(newVal);
    if (newVal && newVal.length > 2) {
      API(controller.Product + action.FindProdsBySplr).post(
        ToFormData({
          supplierId: values.splrId,
          value: newVal,
        }),
        (res) => res?.status === 200 && setProducts([...res.result])
      );
    } else setProducts([]);
  };

  return (
    <div aria-hidden={true}>
      <InputSearch
        disabled={!values.splrId || loading ? true : false}
        value={searchVal}
        loading={loading}
        handleInpChg={handleInpChg}
        handleSelect={handleSelect}
        options={products}
        inputRef={inputRef}
      />

      {!values.splrId && (
        <span className="pl-2 text-[12px] text-yellow-400">
          Please select supplier for add products
        </span>
      )}
      {errorMsg && (
        <span className="text-red-500 font-medium text-[12px] pl-[5px]">
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default InputSelectItem;
